import React from 'react';
import Player from '../../OrgAssessment/Player/index.js';

const Component = props => {
    return <Player {...props} deploymentId={props.deploymentId} isInEditor />;
};

export default Component;
